export const DASHBOARD = {
  originPanel: 'origin-ai-panel',
  originConnectBtn: 'origin-connect-btn',
  originDisconnectBtn: 'origin-disconnect-btn',
  originMessageInput: 'origin-message-input',
  originSendBtn: 'origin-send-btn',
  originApproveBtn: 'origin-approve-btn',
  originAttachBtn: 'origin-attach-btn',
  originClearDraftBtn: 'origin-clear-draft-btn',
  originChatHistory: 'origin-chat-history',
  originInstructionCard: 'origin-instruction-card',
  originEditInstructionBtn: 'origin-edit-instruction-btn',
  originRejectInstructionBtn: 'origin-reject-instruction-btn',
  originRequestClarificationBtn: 'origin-request-clarification-btn',
  
  workspaceCenter: 'interoperability-workspace',
  workspaceMessagesOrigin: 'messages-origin-to-production',
  workspaceActiveProduct: 'active-product-viewer',
  workspaceMessagesProduction: 'messages-production-to-origin',
  
  productionPanel: 'production-ai-panel',
  productionConnectBtn: 'production-connect-btn',
  productionDisconnectBtn: 'production-disconnect-btn',
  productionReplaceBtn: 'production-replace-btn',
  
  sandboxRunBtn: 'sandbox-run-btn',
  sandboxStatus: 'sandbox-status',
  
  approveResultBtn: 'approve-result-btn',
  archiveBtn: 'archive-result-btn',
  deployBtn: 'send-to-production-btn',
  
  navDashboard: 'nav-dashboard',
  navHowToUse: 'nav-how-to-use',
  
  guidedTourStart: 'guided-tour-start-btn',
  
  handoffModal: 'handoff-package-modal',
  handoffCancelBtn: 'handoff-cancel-btn',
  handoffReviewBtn: 'handoff-review-btn',
  handoffConfirmBtn: 'handoff-confirm-btn',
  handoffPackageSummary: 'handoff-package-summary',
  startGuidedDemoBtn: 'start-guided-demo-btn'
};

export const HOME = {
  emergentLink: 'emergent-link'
};